import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Segment,
  Button,
  Form,
  Input,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import {
  cardcolor,
  errorDot,
  errorEmptyText,
  errorMessageText,
  errortilde,
} from '../../../app/common/form/errorMessageText';
import MetaDataComponent from './MetaDataComponent';
import LoadingComponent from './../../../app/layout/LoadingComponent';
import './style.css';
import { MetaDataET } from '../../../app/models/metaDataConfig';
import agent from '../../../app/api/agent';
import { useNavigate } from 'react-router-dom';

const cardStyleLevel4 = {
  display: 'inline-block',
  padding: '10px',
  height: '79vh',
  width: '200pt',
  marginLeft: '2px',
  marginTop: '30px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
  alignItems: 'center',
};

function MetaDataElementType() {
  const history = useNavigate();
  const { metaDataStore, workflowConfigurationStore, commonStore } = useStore();
  const {
    metaDataATRegistry,
    loadMetaDataAT,
    loadMetaDataETById,
    loadMetaDataATById,
    selectedMetaDataAT,
    loadingInitialET,
  } = metaDataStore;

  const [showEdit, setShowEdit] = useState<string>('');
  const [errorType, setErrorType] = useState<string>('');
  const [renamePayload, setRenamePayload] = useState<{
    masterId: string;
    name: string;
  }>({ masterId: '', name: '' });

  useEffect(() => {
    if (metaDataATRegistry.size <= 1) loadMetaDataAT();
  }, [metaDataATRegistry.size, loadMetaDataAT]);

  const handleElementTypes = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      loadMetaDataETById(id); // asset type load child inside
      workflowConfigurationStore.setShowTemplateCard(true); // set elementtype  true
      workflowConfigurationStore.setShowElementTypesName(id); //set element types name
      workflowConfigurationStore.setShowTaskCard(false); // set  task, subtask, element   false
      workflowConfigurationStore.setShowSubTaskCard(false); // set  task, subtask, element   false
      workflowConfigurationStore.setShowElementCard(false); // set  task, subtask, element   false
    }
    workflowConfigurationStore.setEditClickedElement(false);
    workflowConfigurationStore.WorkflowConfiguration.metaDataConfigurationName =
      '';
    cancelClick();
  };

  const handleEdit = (event: any, elementTypes: MetaDataET) => {
    event?.stopPropagation();
    setRenamePayload({
      masterId: elementTypes.id,
      name: elementTypes.elementName,
    });
  };

  const cancelClick = () => {
    setRenamePayload({
      masterId: '',
      name: '',
    });
  };
  const handleChangeName = (e: any, Value: any) => {
    setRenamePayload({
      ...renamePayload,
      name: Value,
    });
    if (Value.includes('~')) {
      setErrorType('tilde');
    } else if (Value?.includes('.')) {
      setErrorType('dot');
    } else {
      const duplicateNameExists = selectedMetaDataAT?.elementTypes.some(
        (item: any) => {
          return item.elementName === Value;
        },
      );
      if (duplicateNameExists) {
        setErrorType('duplicateName');
      } else {
        setErrorType(''); // Clear error type when no errors
      }
    }
  };

  const handleSaveEdited = async () => {
    if (
      !/\s/.test(renamePayload.name?.charAt(0)) &&
      renamePayload.name !== ''
    ) {
      if (renamePayload.masterId !== '') {
        let payload = {
          masterId: renamePayload.masterId || '',
          name: renamePayload.name.trim() || '',
        };
        await agent.WorkLevels.masterRename(payload);
        loadMetaDataATById(
          selectedMetaDataAT?.id || 'e675aa37-34b6-46e5-8cea-c328fe14da09',
        );
        cancelClick();
      }
    } else {
      setErrorType('EmptyName');
    }
  };

  const MetaDataETJSX = (
    <Card className="workflow-config-assettypes">
      {selectedMetaDataAT?.elementTypes.map((elementTypes, index) => (
        <>
          <Card.Content
            key={index}
            style={
              elementTypes.id ===
              workflowConfigurationStore.WorkflowConfiguration
                .showElementTypesName
                ? cardcolor
                : null
            }
            onClick={() => handleElementTypes(elementTypes.id)}
          >
            <Grid className="hoverColor" columns={1}>
              <Grid.Row
                className="master-element"
                onMouseEnter={() => setShowEdit(elementTypes.id)}
                onMouseLeave={() => setShowEdit('')}
              >
                <Grid.Column width={12}>{elementTypes.elementName}</Grid.Column>
                {selectedMetaDataAT?.typeName === 'Masters' &&
                  showEdit === elementTypes.id && (
                    <>
                      <Icon
                        name="mail"
                        color="grey"
                        size="small"
                        onClick={() => {
                          history({
                            pathname: `/CommSettingForDynDash/${elementTypes.id}`,
                          });
                        }}
                      />
                      <Icon
                        name="pencil"
                        color="grey"
                        size="small"
                        className="metadata-edit-icon"
                        onClick={(_e: any) => handleEdit(_e, elementTypes)}
                      />
                    </>
                  )}
              </Grid.Row>
            </Grid>
          </Card.Content>
        </>
      ))}
    </Card>
  );
  return (
    <div>
      <Grid>
        <Card style={cardStyleLevel4}>
          <Header
            style={{ marginLeft: '20px' }}
            size="huge"
            as="h1"
            content="Element Types"
            sub
            color="grey"
          />

          {!selectedMetaDataAT || loadingInitialET ? (
            <LoadingComponent />
          ) : (
            MetaDataETJSX
          )}
          {renamePayload.masterId !== '' &&
            selectedMetaDataAT?.typeName === 'Masters' && (
              <Segment className="metadata-edit workflow-bottom-card">
                <Form>
                  <Form.Group widths="equal">
                    <Form.Field
                      className="metadata-input"
                      error={
                        errorType === 'duplicateName'
                          ? errorMessageText
                          : errorType === 'EmptyName'
                            ? errorEmptyText
                            : errorType === 'dot'
                              ? errorDot
                              : errorType === 'tilde'
                                ? errortilde
                                : null
                      }
                      control={Input}
                      value={renamePayload.name}
                      placeholder="Edit Master Name"
                      onChange={(_e: any, data: any) =>
                        handleChangeName(_e, data?.value)
                      }
                      // onKeyDown={handleKeyPress}
                    />
                  </Form.Group>
                </Form>
                <div className="metadata-input-div">
                  {commonStore.filterModeTwo?.includes('MECABTN01') ? (
                    <></>
                  ) : (
                    <Button
                      secondary
                      onClick={() => cancelClick()}
                      disabled={commonStore.filterModeZero?.includes(
                        'MECABTN01',
                      )}
                    >
                      Cancel
                    </Button>
                  )}
                  {commonStore.filterModeTwo?.includes('MESABTN01') ? (
                    <></>
                  ) : (
                    <Button
                      primary
                      floated="right"
                      onClick={handleSaveEdited}
                      disabled={
                        commonStore.filterModeZero?.includes('MESABTN01') ||
                        errorType === 'duplicateName' ||
                        errorType === 'EmptyName' ||
                        errorType === 'dot' ||
                        errorType === 'tilde'
                      }
                    >
                      Save
                    </Button>
                  )}
                </div>
              </Segment>
            )}
        </Card>
        {workflowConfigurationStore.WorkflowConfiguration
          .showElementTypesCard &&
        workflowConfigurationStore.WorkflowConfiguration.showTemplateCard ? (
          <MetaDataComponent />
        ) : null}
      </Grid>
    </div>
  );
}

export default observer(MetaDataElementType);
